//© 2025 Kaitlyn Troxell
import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { db } from '../firebase';

function useTasks(user, projectId) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTasks = async () => {
      if (!user || !projectId) {
        setTasks([]);
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        const tasksQuery = query(
          collection(db, 'tasks'),
          where('project_id', '==', projectId),
          orderBy('order', 'asc')
        );
        
        const querySnapshot = await getDocs(tasksQuery);
        const tasksList = [];
        
        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          tasksList.push({
            id: docSnap.id,
            title: data.title,
            phase: data.phase,
            contractor: data.contractor,
            completed: data.completed,
            date_completed: data.date_completed,
            notes: data.notes,
            order: data.order,
            project_id: data.project_id,
            subtasks: data.subtasks || []
          });
        });
        
        setTasks(tasksList);
        setError(null);
      } catch (err) {
        console.error("Error fetching tasks:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, [user, projectId]);

  return { tasks, loading, error, setTasks };
}

// Support both default and named exports
export { useTasks };
export default useTasks;